import React, { useState } from "react";
import { Card, Row, Col, Dropdown } from "react-bootstrap";
import {
  FiArrowUpRight,
  FiArrowDownRight,
  FiCalendar,
} from "react-icons/fi";


export default function AttendanceOverviewStatics() {
  const [filter, setFilter] = useState("Today");

  const data = [
    {
      title: "Total Employees",
      value: "2,847",
      percent: "12%",
      up: true,
      color: "green",
      icon: "/assets/img/icons/attendance-icon-1.svg",
      bg: "#f97316",
    },
    {
      title: "Present Today",
      value: "2,458",
      percent: "3.2%",
      up: false,
      color: "red",
      icon: "/assets/img/icons/attendance-icon-2.svg",
      bg: "#164e63",
    },
    {
      title: "Absent Today",
      value: "124",
      percent: "1.4%",
      up: true,
      color: "yellow",
            icon: "/assets/img/icons/attendance-icon-2.svg",
   
      bg: "#facc15",
    },
    {
      title: "Late Arrivals",
      value: "89",
      percent: "12%",
      up: true,
      color: "blue",
         icon: "/assets/img/icons/attendance-icon-3.svg",
    
      bg: "#3b82f6",
    },
    {
      title: "Attendance Rate",
      value: "86.3%",
      percent: "2.5%",
      up: true,
      color: "green",
        icon: "/assets/img/icons/attendance-icon-4.svg",
    
      bg: "#a855f7",
    },
    {
      title: "Pending Regularizations",
      value: "42",
      percent: "7%",
      up: false,
      color: "red",
      icon: "/assets/img/icons/attendance-icon-5.svg",
      bg: "#ef4444",
    },
  ];

  return (
    <Card className="overview-main">
      <Card.Body>
        {/* HEADER */}
        <div className="top-bar">
          <h5>Overview Statistics</h5>

          <Dropdown>
            <Dropdown.Toggle className="date-btn text-dark">
              <FiCalendar /> {filter}
            </Dropdown.Toggle>

            <Dropdown.Menu className="custom-menu">
              {["Today", "Weekly", "Monthly"].map((item) => (
                <Dropdown.Item
                  key={item}
                  onClick={() => setFilter(item)}
                >
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* CARDS */}
        <Row className="g-3">
          {data.map((item, i) => (
            <Col xl={4} md={6} sm={6} xs={12} key={i}>
              <div className="stat-box">
                <div className="left">
                  <p>{item.title}</p>

                  <div className="value-row">
                    <h4>{item.value}</h4>

                    <span className={`badge ${item.color}`}>
                      {item.up ? <FiArrowUpRight /> : <FiArrowDownRight />}
                      {item.percent}
                    </span>

                    <small>vs yesterday</small>
                  </div>
                </div>

                <div
                  className="icon-circle"
                  style={{ background: item.bg }}
                >
                  <img src={item.icon} alt="icon" />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
  <style>
    {
      `
      /* MAIN CARD */
.overview-main {
  border-radius: 5px;
  border: 2px solid #e5e7eb;
  background: #fff;
}

/* HEADER */
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.top-bar h5 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

/* BUTTON */
.date-btn {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 50px !important;
  font-size: 13px;
  padding: 6px 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* DROPDOWN */
.custom-menu {
  padding: 8px;
  border-radius: 10px;
}

/* STAT BOX */
.stat-box {
  background: #f9fafb;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

/* TEXT */
.stat-box p {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 6px;
}

/* VALUE ROW */
.value-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.value-row h4 {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

/* BADGES */
.badge {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;
}

.badge.green {
  background: #16a34a;
  color: #fff;
}

.badge.red {
  background: #ef4444;
  color: #fff;
}

.badge.yellow {
  background: #facc15;
  color: #000;
}

.badge.blue {
  background: #3b82f6;
  color: #fff;
}

/* ICON */
.icon-circle {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-circle img {
  width: 26px;
}

/* ================= MOBILE ================= */
@media (max-width: 768px) {
  .top-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .stat-box {
    padding: 14px;
    align-items: flex-start;
  }

  .left {
    flex: 1;
  }

  .value-row h4 {
    font-size: 18px;
  }

  .badge {
    font-size: 10px;
    padding: 3px 6px;
  }

  .value-row small {
    width: 100%;
    font-size: 11px;
  }

  .icon-circle {
    width: 46px;
    height: 46px;
  }

  .icon-circle img {
    width: 22px;
  }
}`
    }
  </style>
    </Card>
  );
}